import { render } from "./common-menu-popover.vue?vue&type=template&id=6a48ce31&ts=true"
import script from "./common-menu-popover.vue?vue&type=script&lang=ts"
export * from "./common-menu-popover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__